import { useAtomValue } from 'jotai';
import { dcaNotificationAtom } from '../atoms';
import { useMemo } from 'react';
import { InlineNotification } from '@carbon/react';
import styles from './dca-notifications.module.scss';

export const DcaNotifications = () => {
  const notificationData = useAtomValue(dcaNotificationAtom);

  const notifications = useMemo(() => {
    return Object.values(notificationData)
      .flat()
      .sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));
  }, [notificationData]);

  if (notifications.length === 0) return null;

  return (
    <div className={styles.notificationsContainer}>
      {notifications.map((notification) => (
        <InlineNotification
          className={styles.inlineNotification}
          lowContrast
          key={notification.id}
          title={notification.title}
          subtitle={notification.message}
          kind={notification.type}
          hideCloseButton={notification.hideCloseButton ?? true}
        />
      ))}
    </div>
  );
};
